import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api/config';
import './LoginForm.css';

function LoginForm({ onLogin, onJoin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/auth/login`,
        { username, password },
        { timeout: 90000 }
      );
      onLogin({ username: res.data.username, nickname: res.data.nickname });
    } catch (err) {
      let msg = err.response?.data?.message || err.message;
      if (err.code === 'ECONNABORTED') {
        msg = '서버 응답이 늦습니다. Render가 깨어나는 중일 수 있어요. 잠시 후 다시 시도하세요.';
      } else if (err.code === 'ERR_NETWORK' || !err.response) {
        msg = '서버에 연결할 수 없습니다. 잠시 후 다시 시도하세요.';
      }
      alert('로그인 실패: ' + msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <img src="/images/logoTextWhite.png" alt="공구나라 로고" className="login-logo" />
      </div>
      <div className="login-right">
        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-title">로그인</h2>
          <label htmlFor="username" className="login-label">아이디</label>
          <input
            type="text"
            id="username"
            name="username"
            className="login-input"
            value={username}
            onChange={e => setUsername(e.target.value)}
            disabled={loading}
          />
          <label htmlFor="password" className="login-label">비밀번호</label>
          <input
            type="password"
            id="password"
            name="password"
            className="login-input"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
          />
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? '연결 중… (최대 1분)' : '로그인'}
          </button>
          <button type="button" className="signup-btn" onClick={onJoin} disabled={loading}>
            회원가입
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
